import { always } from 'ramda'

const VehiclesPermissions = {
  read: always(true),
}

export default VehiclesPermissions
